import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';

export const ThumbnailHeight = 177;
export const TileWidth = 332;

export const Wrapper = styled.div.attrs({
  className: 'bg-white grid relative text-blue-7'
})`
  border-radius: 6px;
  width: ${TileWidth}px;
  grid-template-rows: ${ThumbnailHeight}px 1fr;

  &:hover {
    box-shadow:
      0 8px 28px rgba(24, 53, 88, 0.04),
      0 4px 8px rgba(24, 53, 88, 0.07),
      0px -2px 8px rgba(24, 53, 88, 0.03);
  }

  &.loader {
    &::after {
      backdrop-filter: blur(5px);
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      z-index: 1;
    }
    animation: pulse 3s infinite;

    @keyframes pulse {
      50% {
        opacity: 0.5;
      }
    }
  }
`;

export const DetailsWrapper = styled.div.attrs({
  className: 'grid px-16 py-12 text-blue-7'
})`
  grid-template-rows: auto 72px 1fr;
`;

export const DetailsGrid = styled.div.attrs({
  className: 'gap-4 grid'
})`
  grid-template-rows: 12px 24px 20px;
`;

export const YearMakeModel = styled.p.attrs({
  className: 'font-bold truncate'
})`
  font-size: 18px;
  line-height: 24px;
`;

export const TrimAndMileage = createComponent('div', {
  className: 'tl-body-s'
});

export const Price = styled.p.attrs({
  className: 'flex-1 font-bold'
})`
  font-size: 24px;
  line-height: 32px;
`;

export const LowerSectionWrapper = styled.div.attrs({
  className: 'gap-4 grid mt-4'
})`
  grid-template-columns: 1fr;
  grid-template-rows: 20px;
`;

export const LowerSectionItem = styled.div.attrs({
  className: 'gap-8 grid'
})`
  grid-template-columns: 20px 1fr;
`;
